// extracted by mini-css-extract-plugin
module.exports = {"user":"UserInfo_user__3NxFY","userImage":"UserInfo_userImage__3wyeo","userName":"UserInfo_userName__a3Fo9"};